import { apiClient } from '@/core/api/client';
import type { Report } from '../types/reports.types';

interface ReportsResponse {
  success: boolean;
  data: {
    reports: Report[];
    pagination: {
      current_page: number;
      total_pages: number;
      total_items: number;
      items_per_page: number;
      has_next: boolean;
      has_previous: boolean;
    };
    filters_applied?: Record<string, any>;
  };
  timestamp: string;
}

interface ReportDetailResponse {
  success: boolean;
  data: Report;
  timestamp: string;
}

export const reportsApi = {
  /**
   * Fetches reports list for the authenticated client
   * Client ID is automatically determined from the authenticated user session
   * @returns Promise with reports array and pagination info
   */
  fetchReports: async (): Promise<ReportsResponse> => {
    try {
      const response = await apiClient.get('/api/client/reports');
      return response as ReportsResponse;
    } catch (error) {
      console.error('Error fetching client reports:', error);
      throw error;
    }
  },

  /**
   * Fetches a single report by ID for the authenticated client
   * @param reportId - The ID of the report to fetch
   * @returns Promise with the report details
   */
  fetchReportById: async (reportId: string | number): Promise<ReportDetailResponse> => {
    try {
      const response = await apiClient.get(`/api/client/reports/${reportId}`);
      return response as ReportDetailResponse;
    } catch (error) {
      console.error('Error fetching report details:', error);
      throw error;
    }
  }
};